module.exports = __webpack_public_path__ + "img/arrow-right.3d63cb6a.png";